import { createFileRoute } from '@tanstack/react-router'
import WhatsAppSistemaPage from '@/pages/dashboard/whatsapp-sistema-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/',
)({
  component: function WhatsAppSistemaIndexRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <WhatsAppSistemaPage />
      </ProtectedRoute>
    )
  },
})
